import React, { useState } from 'react';
import { observer } from 'mobx-react-lite';
import { FilesState } from 'src/AppState/FilesState/FilesState';
import { FilesListCMSModelType } from 'src/api/config/filesCMS/getCMSFilesList';
import { FileItemComponentState } from 'src/components/FilesPopup/FileItemComponent.state';
import { DeleteWrapper, Image, ImageWrapper } from 'src/components/FilesPopup/FileItemComponent.style';

interface PropsTypesFileItemComponent {
    dataTest?: string;
    file: FilesListCMSModelType;
    filesState: FilesState;
    onChooseImage: (id: string) => void;
    onDeleteImage: (id: string) => void;
    hideDeleteButton?: boolean;
}

export const FileItemComponent = observer(
    ({ file, filesState, onChooseImage, onDeleteImage, dataTest, hideDeleteButton }: PropsTypesFileItemComponent) => {
        const [state] = useState(() => new FileItemComponentState(filesState, file, onChooseImage, onDeleteImage));

        return (
            <ImageWrapper>
                <Image data-test={dataTest} src={file.media_link} onClick={state.handleChooseGame} />
                {hideDeleteButton === true ? null : (
                    <DeleteWrapper onClick={state.handleDeleteGame}>DELETE</DeleteWrapper>
                )}
            </ImageWrapper>
        );
    }
);
